<template>
  <div class="shadow_nr" v-show="pullBox" v-on:click="cancelpullBox(false)" style="z-index: 999999">
    <transition name="pull-up">
      <div class="shadow-cont" v-show="cont" v-on:click="clickTest">
        <div class="album-list">
          <ul class="clear">
            <li @click="option('startVideoCapture')">カメラ</li>
            <li @click="option('captureImage')">アルバムから選択</li>
          </ul>
        </div>
        <div class="cancel cancel1" @click="cancelpullBox(false)">キャンセル</div>
      </div>
    </transition>
  </div>

</template>

<script>
  export default {
    data () {
      return {
        pullBox: false,
        cont: false,
        album: null,
        camera: null,
        file: null
      }
    },
    methods: {
      cancelpullBox (val) {
        this.cont = val
        if (!val) {
          setTimeout(() => {
            this.pullBox = val
          }, 300)
        } else {
          this.pullBox = val
        }
      },
      option (str) {
        if (str === 'captureImage') {
          if (this.album) {
            this.album()
            this.cancelpullBox(false)
          }
        } else {
          if (this.camera) {
            this.camera()
            this.cancelpullBox(false)
          }
        }
      },
      clickAudio () {
        this.$refs.filElem.dispatchEvent(new MouseEvent('click')) 
      },
      clickTest (e) {
        e.stopPropagation()
      },
      setItem (o) {
        this.item = o
      }
    }
  }
</script>

<style lang="less" scoped>
  /*......朋友圈隐藏下拉........*/
  .album-list {
    border-bottom: 10px solid #f2f2f2;
  }

  .album-list ul li {
    text-align: center;
    line-height: 40px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 17px;
  }

  .album-list ul li p {
    color: #999;
    line-height: 0;
    margin-bottom: 17px;
  }

  .cancel1 {
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/uploadTool/uploadTool.vue